import { useLocation, Navigate } from "react-router-dom";
import { React, useEffect, useState } from 'react';

// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Divider, Typography } from '@mui/material';
import URLS from '../../../services/urls.service';
// components
import Page from '../../../components/Page';
import ServiceRequestBDTrackerDetails from "../../../components/SidebarMenuComponents/ServiceRequestComponent/ServiceRequestBDTrackerDeatils";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ServiceRequestBDTracker() {


    const location = useLocation();
    const { tracker, loadTrackerData, trackerMasterId, trackerName } = location.state;
    const ticketId = tracker?.DataTable?.[0]?.ID ?? "";

    console.log("details", loadTrackerData, trackerMasterId, tracker, "tracker>>>>>", tracker)
    return (

        <Page title={trackerName || "tiketic"} >

            <StickyHeader title={trackerName || "Service Request Incident Tracker"} showRightLabel rightLabel={ticketId ? `Ticket ID: ${ticketId}` : ""} />

            <ContentStyle>
                <ServiceRequestBDTrackerDetails loadTrackerData={loadTrackerData} tracker={tracker} trackerMasterId={trackerMasterId} />
            </ContentStyle>
        </Page>
    );
}

